import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AuthService from '../../controllers/AuthService';
import MenuCard from './MenuCard';
import ReportSummary from '../riasec/ReportSummary';
import TopStrengthInRoom from './Parts/Activity/TopStrengthInRoom';
import UserService from '../../controllers/UserService';


const Activity = props => {

    const [isShowDetail, setIsShowDetai] = useState(false);
    const [totalStudentCount, setTotalStudentCount] = useState(0);
    const [totalTeacherCount, setTotalTeacherCount] = useState(0);
    const [yearTermSelection, setYearTermSelection] = useState(null);
    const [termSelected, setTermSelected] = useState(null); // for current selected {year: x, term: y}
    const [gradeSelected, setGradeSelected] = useState(null); // for current selected primary or secondary
    const [roomSelected, setRoomSelected] = useState(null); // for current selected {gradeYear: 1, roomNo: 2}
    const [yearsList, setYearsList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [roomsList, setRoomsList] = useState([]);
    const [roomsListShow, setRoomsListShow] = useState([]);
    const [currentRoom, setCurrentRoom] = useState(null);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        const userDomain = user.domain.name;
    
        UserService.distinctYearTerm().then((response) => {
            var yearTerm = response?.data?.data.reverse();
            console.log('yearTerm', yearTerm)
            setYearsList(yearTerm)

            let ytText
            let yTS = []
            for (const [key, value] of Object.entries(yearTerm)) {
                ytText = yearTerm[key].term + '/' + yearTerm[key].year;
                yTS.push({
                    value: ytText,
                    text: ytText,
                })
            };
            setYearTermSelection(yTS)
            return yearTerm;
        }).then((yearTerm) => {
            // UserService.getRoomList({ id: user.id, domain: userDomain }).then((response) => {
            //     const rooms = response?response.data.data:[];
            //     setRoomsList(rooms)
            //     console.log('out response')
            //     console.log(response)
            // })

  
                var allData = [];  
                var tempData = [];
                var countTemp = 0;
                var countLoop = 0;      
                countTemp = yearTerm.length;
                yearTerm.forEach(function (element, i) {   
                // console.log('----------------------------------------');        
                // console.log(userDomain,element.term,element.year);
                UserService.getRoomList({ id: user.id, domain: userDomain, term: element.term, year: element.year }).then((response) => {
                       
                        if(response.data && response.data.data){
                            console.log(response.data.data);
                            allData = [...allData,...response.data.data];
                        }
                       response.data.data = allData;    
                       tempData = response ;
                       return tempData;
                    }).then((tempData) => {
                        // console.log('tempData');
                        // console.log(tempData);
                        countLoop++
                        if(countTemp == countLoop){                           
                            const rooms = tempData?tempData.data.data:[];
                            // console.log('rooms');
                            // console.log(rooms);
                            setRoomsList(rooms)
                           
                        }                    
                    })
                
                });                
           
           
        }).then(() => {
            dropdownClassesCompute(null)
        });



    }, [])

    const dropdownClassesCompute = (e) => {
        let setTermVal = null
        setGradeSelected(null)
        setRoomSelected(null)
        let selectedVal = e?.target?.value
        if (!selectedVal && e?.defaultDropdown) selectedVal = e?.defaultDropdown
        let classYear = null
        if (selectedVal) classYear = selectedVal.split("/")
        if (classYear && classYear.length === 2) {
            setTermVal = { year: classYear[1], term: classYear[0] }
            console.log('juuuuuuuuuuuuuuuu')
            console.log(roomsList);
            // var sGrade = [];
            // var pGrade = [];
            const sGrade = roomsList.filter(function (val) { return val.grade.includes("SECONDARY") && val.term === parseInt(classYear[0]) && val.year === parseInt(classYear[1]) });
            const pGrade = roomsList.filter(function (val) { return val.grade.includes("PRIMARY") && val.term === parseInt(classYear[0]) && val.year === parseInt(classYear[1]) });
            // roomsList.forEach(function(val, i) {
            //     if(val.grade.includes("SECONDARY") && val.term === parseInt(classYear[0]) && val.year === parseInt(classYear[1])) {
            //         console.log(i,val.term,val.year);
            //         console.log(i,classYear[0],classYear[1]);
            //         sGrade.push(val)
            //     }

            //     if(val.grade.includes("PRIMARY") && val.term === parseInt(classYear[0]) && val.year === parseInt(classYear[1])) {
            //         pGrade.push(val)
            //     }
            // });

            let classes = []
            if (sGrade && sGrade.length > 0) {
                classes.push({
                    value: 'SECONDARY',
                    text: 'มัธยมศึกษา',
                })
            }
            if (pGrade && pGrade.length > 0) {
                classes.push({
                    value: 'PRIMARY',
                    text: 'ประถมศึกษา',
                })
            }
            setClassList(classes)
            console.log('sGrade', sGrade)
            console.log('pGrade', pGrade)
        }
        console.log(setTermVal, 'setTermVal')
        setTermSelected(setTermVal)
    }

    const dropdownGradeCompute = (e) => {
        setGradeSelected(null)
        setRoomSelected(null)
        let selectedVal = e?.target?.value
        let classYear = null
        if (selectedVal) {
            setGradeSelected(selectedVal)
            if (termSelected) classYear = termSelected
            const rooms = roomsList.filter(function (val) { return val.grade.includes(selectedVal) && val.term === parseInt(classYear.term) && val.year === parseInt(classYear.year) });
            console.log('rooms', rooms)
            if (rooms && rooms.length > 0) {
                let tmp = ''
                let optionVal = []
                for (const [key, value] of Object.entries(rooms)) {
                    tmp = rooms[key].gradeYear + '/' + rooms[key].roomNo;
                    optionVal.push({
                        value: tmp,
                        text: tmp,
                    })
                };
               
                setRoomsListShow(optionVal)
            }
        }
    }

    const dropdownRoomCompute = (e) => {
        let setRoomVal = null
        let selectedVal = e?.target?.value
        if (selectedVal) {
            const roomDetail = selectedVal.split("/")
            setRoomVal = { gradeYear: parseInt(roomDetail[0]), roomNo: parseInt(roomDetail[1]) }
        }
    
        setRoomSelected(setRoomVal)
        return;
    }

    const showDetail = () => {
        setCurrentRoom(null)
        if (termSelected && gradeSelected && roomSelected) {
            let getRoom = null
            const rooms = roomsList.filter(function (val) { return val.grade.includes(gradeSelected) && val.term === parseInt(termSelected.term) && val.year === parseInt(termSelected.year) && val.gradeYear === roomSelected.gradeYear && val.roomNo === roomSelected.roomNo });
            if (rooms && rooms.length > 0) {
                getRoom = rooms[0]
            }
            setCurrentRoom(getRoom)
            setIsShowDetai(true)
            computeTotalTeacherStudentInRoom(getRoom)
        }
    }

    const computeTotalTeacherStudentInRoom = (room = null) => {
        if (!room) {
            return;
        }
        setTotalStudentCount(room.students?.length)
        setTotalTeacherCount(room.teachers?.length)

    }

    return (
        <>
            <Row className='activity-page mb-3 mb-lg-5'>
                <Col xs={12} className='text-center my-3'><span className='headmaster-name'>ผู้อำนวยการ : {AuthService.getUserFullName()}</span></Col>
                <Col xs={12}>
                    <Row className='selector mx-3 mx-lg-0'>
                        <div className="inner-selector">
                        <div className='font-sarabun-bold text-center text-lg-right my-1 my-lg-0 d-lg-flex'>
                            <div className='d-lg-inline'>ภาคการศึกษา</div>
                            <div className='d-lg-inline px-3'>
                                <select className="form-control form-control-sm border-radius-5 font-sarabun custom-dropdown" onChange={dropdownClassesCompute}>
                                    <option disabled selected>เลือก</option>
                                    {
                                        (yearTermSelection && yearTermSelection.length > 0) ? (
                                            yearTermSelection.map((item, index) => (
                                                <option value={item.value} key={index}>{item.text}</option>
                                            ))
                                        ) : (
                                            <span className='d-none' />
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className='font-sarabun-bold text-center text-lg-right my-1 my-lg-0 d-lg-flex'>
                            <div className='d-lg-inline ml-0 ml-lg-3 mt-3 mt-lg-0'>ระดับชั้น</div>
                            <div className='d-lg-inline px-3'>
                                <select className="form-control form-control-sm border-radius-5 font-sarabun custom-dropdown" onChange={dropdownGradeCompute} disabled={classList.length === 0}>
                                    <option disabled value selected={classList.length === 0 || gradeSelected === null} >เลือก</option>
                                    {
                                        (classList && classList.length > 0) ? (
                                            classList.map((item, index) => (
                                                <option value={item.value} key={index}>{item.text}</option>
                                            ))
                                        ) : null
                                    }
                                </select>
                            </div>
                        </div>
                        <div className='font-sarabun-bold text-center text-lg-right my-1 my-lg-0 d-lg-flex'>
                            <div className='d-lg-inline ml-0 ml-lg-3 mt-3 mt-lg-0'>ห้อง</div>
                            <div className='d-lg-inline px-3'>
                                <select className="form-control form-control-sm border-radius-5 font-sarabun custom-dropdown" onChange={dropdownRoomCompute} disabled={gradeSelected === null}>
                                    <option disabled value selected={gradeSelected === null || roomSelected === null} >เลือก</option>
                                    {
                                        (roomsListShow && roomsListShow.length > 0) ? (
                                            roomsListShow.map((item, index) => (
                                                <option value={item.value} key={index}>{item.text}</option>
                                            ))
                                        ) : null
                                    }
                                </select></div>
                        </div>
                        <div className='text-center text-lg-left my-1 my-lg-0 ml-0 ml-lg-3'>
                            <Button onClick={() => showDetail()} disabled={roomSelected === null} className={`mt-3 mt-lg-0 search-class ${roomSelected === null ? 'inactive' : 'active'}`}>Search</Button>
                        </div>
                        </div>
                    </Row>
                </Col>
                {isShowDetail && currentRoom ? (
                    <>
                        <Col xs={12}>
                            <Row className="font-sarabun my-3">
                                <Col xs={12} className="text-center current-room my-3">
                                    ห้อง {currentRoom.displayName}
                                </Col>
                                <Col xs={12} lg={6} className="">
                                    <h3 className="text-center text-lg-right pl-lg-0 mb-0 total-text" data-testid="dashboard-domain-homeroom-total-student"><img src="/images/icons/person_icon.png" width="15" className="mb-2" /> นักเรียนทั้งหมด {totalStudentCount} คน</h3>
                                </Col>
                                <Col xs={12} lg={6} className="">
                                    <h3 className="text-center text-lg-left pl-lg-0 mb-0 total-text" data-testid="dashboard-domain-homeroom-total-teacher"><img src="/images/icons/person_icon.png" width="15" className="mb-2" /> คุณครูทั้งหมด {totalTeacherCount} คน</h3>
                                </Col>

                            </Row>
                        </Col>
                        <Col xs={12}>
                            {(currentRoom?.id) ? <MenuCard roomId={currentRoom.id} /> : null}
                        </Col>
                        <Col xs={12}>
                            {(currentRoom?.id) ? <TopStrengthInRoom filterYear={currentRoom.year} filterTerm={currentRoom.term} roomId={currentRoom.id} /> : null}
                        </Col>
                        <Col xs={12}>
                            {(currentRoom?.id) ? <ReportSummary roomId={currentRoom.id} customTitle="ผลประเมินแบบทดสอบความสนใจทางอาชีพในห้องเรียน" customBorder={true} customSubtitle="จากการทำประเมินแล้ว" showFor="room" /> : null}
                        </Col>
                    </>
                ) : (
                    <Col xs={12} className='text-center my-4 new-grey-text'>
                        <h3>กรุณาระบุข้อมูลที่ต้องการค้นหา</h3>
                    </Col>
                )}
            </Row>
        </>
    )


}

export default Activity